import { render } from "./CertAlcoholPendingReview.vue?vue&type=template&id=7f7e438a&scoped=true"
import script from "./CertAlcoholPendingReview.vue?vue&type=script&lang=js"
export * from "./CertAlcoholPendingReview.vue?vue&type=script&lang=js"

import "./CertAlcoholPendingReview.vue?vue&type=style&index=0&id=7f7e438a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7e438a"]])

export default __exports__